import { FC } from 'react';
import * as React from 'react';

import { Loader } from '@crehana/ui';
import { useUITheme } from '@crehana/web';

const BootcampSkeleton: FC<
  React.PropsWithChildren<{ 'data-testid'?: string }>
> = ({ 'data-testid': dataTestId }) => {
  const { isDark } = useUITheme();

  return (
    <div
      className={`flex items-center justify-center py-80 ${
        isDark ? 'bg-base-lighter-8' : 'bg-white'
      }`}
      data-testid={dataTestId}
    >
      <Loader white={isDark} />
    </div>
  );
};

export default BootcampSkeleton;
